import * as React from 'react';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import useTranslation from "../customHooks/translations";

const DatePickerComponent = ({ value, onChange, label, sx }) => {
  const translation = useTranslation();
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <MobileDateTimePicker
        label={label || translation.datePicker.placeholders.select}
        value={value && value !== 'none' ? dayjs(value) : null}
        onChange={(val) => onChange(val?.toISOString())}
        slotProps={{
          textField: {
            size: 'small',
            fullWidth: true,
            sx,
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default DatePickerComponent;
